// The canonical host the server marks in the page (<meta name="tb-canonical-host">, lib/canonical-host.js,
// TEAMBRIDGE_CANONICAL_HOST). The app's head tags (canonicals and og:url/og:image set by Helmet on the homepage,
// /pricing and the drawing guide) move to that host; without the marker (flag unset) nothing changes.
// Plain ESM with no imports.
const ORIGIN = /^https?:\/\/(?:www\.)?teambridge\.app(?=[/?#]|$)/i;
const TAGS = [['link[rel="canonical"]', 'href'], ['meta[property="og:url"]', 'content'], ['meta[property="og:image"]', 'content'], ['meta[name="twitter:image"]', 'content']];
export function canonicalHost(doc = typeof document === 'undefined' ? null : document) {
  const host = doc?.querySelector?.('meta[name="tb-canonical-host"]')?.getAttribute('content');
  return host && /^[a-z0-9.-]+$/i.test(host) ? host : null;
}
export function canonicalHref(url, doc) {
  const host = canonicalHost(doc);
  return host && typeof url === 'string' ? url.replace(ORIGIN, `https://${host}`) : url;
}

// Moves the head tags now, and again whenever Helmet changes the head. Returns a stop function.
export function followCanonicalHost(doc = typeof document === 'undefined' ? null : document, Observer = typeof MutationObserver === 'undefined' ? null : MutationObserver) {
  if (!canonicalHost(doc) || !doc.head) return () => {};
  const fix = () => TAGS.forEach(([selector, attribute]) => doc.head.querySelectorAll(selector).forEach(tag => {
    const value = tag.getAttribute(attribute);
    const next = canonicalHref(value, doc);
    if (next !== value) tag.setAttribute(attribute, next);
  }));
  fix();
  if (!Observer) return () => {};
  const observer = new Observer(fix);
  observer.observe(doc.head, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['href', 'content']
  });
  return () => observer.disconnect();
}